import * as React from 'react';
import type {ComponentType} from 'react';
import type {View} from '@sail/engine';

/**
 * Context for injecting the LayerInterop component.
 *
 * This allows stable @sail/ui Layer to use deprecated token propagation
 * without directly depending on deprecated code. The context is intentionally
 * in a separate file from LayerInterop to ensure tree-shaking works correctly:
 * importing just the context won't pull in @sail/engine/deprecated.
 *
 * Usage:
 * - @sail/ui imports only LayerInteropContext (no deprecated dependency)
 * - @sail/theme-classic Provider sets the context value to LayerInterop
 * - Apps using deprecated components get token propagation in layers
 * - Apps using only stable components can skip the Provider (or use noInterop)
 */
export const LayerInteropContext = React.createContext<ComponentType<
  View.IntrinsicElement<'div'>
> | null>(null);
